// extracted by css-extract-rspack-plugin
export default {"emptyState":"emptyState-fFDV35","glyph":"glyph-ctcGqx","heading":"heading-aWusyF","body":"body-z2KF5H","ctaButton":"ctaButton-LvkJTs"};